// extracted by mini-css-extract-plugin
module.exports = {"lucky_history":"History_lucky_history__GHgTS","luckyhistory_select_pop":"History_luckyhistory_select_pop__c_gLf"};